//import { useState } from "react";
import { Button } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';

const RealtimeStatus = ({status}) => {

  //  const [showspinner, setShowSpinner] = useState(true);

  let ButtonVariant = "";  
  let SpinnerClass = "";  
  let ShowSpinner = false;

  if (status == "In Progress") {    
    
    ButtonVariant = "primary";
    SpinnerClass = "";
    ShowSpinner = true;

  } else {

    if (status == "Delay") {    
      ButtonVariant = "warning";
      SpinnerClass = "danger";
    } else {
    
      if (status == "Completed") {    
          ButtonVariant = "info";
          SpinnerClass = "";        
          ShowSpinner = false;
        }else{

          if(status == "No staff"){
            ButtonVariant = "outline-danger";
            SpinnerClass = "";        
            ShowSpinner = false;  
          }
          else{
            ButtonVariant = "outline-primary";
            SpinnerClass = "";        
            ShowSpinner = false;
          }
        }

    } 
  }

  return (
    <Button size="sm" variant={ButtonVariant} disabled>
        {ShowSpinner && <Spinner animation="grow" variant={SpinnerClass} size="sm"/>}
        <span className="ms-1">{status}</span>
    </Button>
  )
}

export default RealtimeStatus